import React from "react";

export default function CRMReportsDashboard() {
  return (
    <div>

      <div
        style={{
          background:
            "linear-gradient(135deg,#7c3aed,#8b5cf6)",
          borderRadius: "16px",
          padding: "20px",
          color: "#fff",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ margin: 0 }}>
          CRM Reports Dashboard
        </h2>

        <div style={{ marginTop: "8px" }}>
          Reporting & Export Center
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(250px,1fr))",
          gap: "16px",
        }}
      >
        <div className="card p-3">
          Enquiry Reports
        </div>

        <div className="card p-3">
          Quotation Reports
        </div>

        <div className="card p-3">
          Order Reports
        </div>

        <div className="card p-3">
          Customer Reports
        </div>
      </div>

    </div>
  );
}